// extracted by mini-css-extract-plugin
export default {"title":"ProfileCompletedForm_title-NFlB6"};